import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import { V2, pickLang } from "../copy";
import { Arrow } from "./Primitives";
import { route } from "../paths";

const B2BV2: React.FC = () => {
  const { currentLanguage } = useLanguage();
  const lang = pickLang(currentLanguage);
  const c = V2[lang].b2b;

  return (
    <section id="v2-b2b" className="bg-ink py-16 text-bone sm:py-24">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6">
        <div className="v2-reveal grid overflow-hidden rounded-2xl bg-bone text-ink md:grid-cols-2">
          <div className="flex flex-col p-7 sm:p-12">
            <div className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.22em] text-ink/60">
              <span className="h-2 w-2 rounded-full bg-teal" />
              {c.label}
            </div>
            <h2 className="mt-6 font-display text-[clamp(2.2rem,5vw,4.5rem)] leading-[0.95] tracking-[-0.02em]">
              {c.title}
            </h2>
            <p className="mt-5 max-w-md text-ink/65">{c.desc}</p>
            <div className="mt-6 flex flex-wrap gap-2">
              {c.segments.map((s) => (
                <span
                  key={s}
                  className="rounded-full border border-ink/20 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.18em]"
                >
                  {s}
                </span>
              ))}
            </div>
            <div className="mt-auto pt-8">
              <Link to={route(lang, "entreprises")} className="v2-btn v2-btn-ink">
                {c.cta}
                <Arrow />
              </Link>
            </div>
          </div>
          <div className="relative aspect-[4/3] md:aspect-auto md:min-h-[420px]">
            <img
              src="/illustrations/landing/entreprises.webp"
              alt=""
              loading="lazy"
              className="absolute inset-0 h-full w-full object-contain object-bottom p-4 md:object-right-bottom md:p-8"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default B2BV2;
